import { MapInitOptions } from '../types/mapTypes';

export const MAP_INIT_OPTIONS: Partial<MapInitOptions> = {
  style: 'mapbox://styles/mapbox/streets-v12',
  zoom: 13,
  minZoom: 9,
  maxZoom: 18
};

export const POPUP_OPTIONS = {
  offset: 25,
  closeButton: true,
  closeOnClick: false,
  maxWidth: '300px'
} as const;

export const MAP_ERRORS = {
  INIT_FAILED: {
    code: 'MAP_INIT_FAILED',
    message: 'Échec de l\'initialisation de la carte',
    severity: 'error'
  },
  GEOCODING_FAILED: {
    code: 'GEOCODING_FAILED',
    message: 'Échec de la géolocalisation',
    severity: 'error'
  }
} as const;

